import { Base, User } from "../../../../core/db/models/index";
import { Measurement, MeasurementLike } from "./measurement";
import DeconCleansingTypeUsage, { CleansingTypeUsageLike, CleansingInstanceLike, CleansingInstance } from "./cleansingTypeusage";
import { OrderLike, OfflineMixin } from "./order";
import FortumDatabase from "../../index";
import { WithAllType, arrayOrCollection } from "../../../../core/db/index";

export interface OrderItemAssignmentLike extends Base, OfflineMixin
{
    item_id: number;
    user_id: number;

    item?: OrderItemLike;
    user?: User;
}

export interface OrderItemLike extends Base, OfflineMixin
{
    order_id: number;
    name: string;
    count: number;

    state: string;
    measurements?: MeasurementLike[];
    cleansing_instances?: CleansingInstanceLike[];
    order?: OrderLike;
    assignments?: OrderItemAssignmentLike[];
}

export class OrderItem implements OrderItemLike
{
    public static readonly STATE_NEW = 'new';
    public static readonly STATE_STARTED = 'started';
    public static readonly STATE_COMPLETED = 'completed';

    public static readonly STATE_SORT = {
        [OrderItem.STATE_NEW]: 0,
        [OrderItem.STATE_STARTED]: 1,
        [OrderItem.STATE_COMPLETED]: 2
    };

    is_offline: 1 | 0;
    order_id: number;
    state: string;
    count: number;
    name: string;
    measurements?: MeasurementLike[];
    cleansing_types?: CleansingTypeUsageLike[];
    order?: OrderLike;
    created_at?: Date;
    modified_at?: Date;
    id?: number;
    
    public static withAll(db: FortumDatabase, targetOrderItems: WithAllType<OrderItemLike>): PromiseLike<OrderItemLike[]>
    {
        let orderItems: OrderItemLike[];

        return arrayOrCollection(targetOrderItems).then((resolvedOrderItems) =>
        {
            orderItems = resolvedOrderItems;
            let promises: PromiseLike<any>[] = [];

            promises.push(db.DeconMeasurement.where('item_id').anyOf(orderItems.map(o => o.id)).toArray());
            promises.push(db.DeconCleansingInstance.where('item_id').anyOf(orderItems.map(o => o.id)).toArray());
            promises.push(db.DeconOrderItemAssignment.where('item_id').anyOf(orderItems.map(o => o.id)).toArray());

            if (!orderItems.find(o => o.order != null))
            {
                promises.push(db.DeconOrder.where('id').anyOf(orderItems.map(o => o.order_id)).toArray());
            }

            return Promise.all(promises);
            
        }).then((results) =>
        {
            let measurements: MeasurementLike[] = results[0];
            let cleansingInstances: CleansingInstanceLike[] = results[1];
            let assignments: OrderItemAssignmentLike[] = results[2];
            let orders: OrderLike[] = results[3];

            for(let orderItem of orderItems)
            {
                orderItem.measurements = measurements.filter(o => o.item_id == orderItem.id);
                orderItem.cleansing_instances = cleansingInstances.filter(o => o.item_id == orderItem.id);
                orderItem.assignments = assignments.filter(o => o.item_id == orderItem.id);

                if (orders && !orderItem.order)
                {
                    orderItem.order = orders.find(o => o.id == orderItem.order_id);
                }
            }

            return Promise.all([
                CleansingInstance.withAll(db, cleansingInstances),
                Measurement.withAll(db, measurements),
                OrderItemAssignment.withAll(db, assignments)
            ]);
        }).then(() =>
        {
            return orderItems;
        });
    }

    public static trySetStarted(db: FortumDatabase, order_id: number, item_id: number) {
        return Promise.all([
            db.DeconOrder
                .where('id').equals(order_id)
                .and(order => order.state === 'new')
                .modify({state: 'started', is_offline: 1}),
            db.DeconOrderItem
            .where('id').equals(item_id)
            .and(item => item.state === 'new')
            .modify({state: 'started', is_offline: 1}),
        ]);
    }
}

export class OrderItemAssignment implements Partial<OrderItemAssignmentLike>
{
    public static withAll(db: FortumDatabase, targets: WithAllType<OrderItemAssignmentLike>): PromiseLike<OrderItemAssignmentLike[]>
    {
        let results: OrderItemAssignmentLike[];

        return arrayOrCollection(targets).then((resolved) =>
        {
            results = resolved;
            return Promise.all([
                db.User.where('id').anyOf(results.map(o => o.user_id).filter(o => o != null)).toArray(),
            ]);
        }).then((data) =>
        {
            let users: User[] = data[0];

            for (let result of results)
            {
                result.user = users.find(o => o.id == result.user_id);
            }
        }).then(() =>
        {
            return results;
        });
    }
}